export enum SystemErrorName {
    sensorBatteryLow = 0,
    inconsistentBox = 1,
    sensorTamper = 2,
    sensorMissing = 3,
    biometricDeviceUnavailable = 4,
    dmpPanelUnavailable = 5,

    // 6 and 7 are deliberately skipped so these values stay aligned with SiteIssueType,
    // where 6 is DoorLeftOpen and 7 is BoxLeftOpen - neither is a system error.
    hmiUnavailable = 8
}

export const SystemErrorNameDisplay = new Map([
    [SystemErrorName.sensorBatteryLow, 'Sensor Battery Low'],
    [SystemErrorName.inconsistentBox, 'Box in Inconsistent State'],
    [SystemErrorName.sensorTamper, 'Sensor Tampered'],
    [SystemErrorName.sensorMissing, 'Sensor Missing'],
    [SystemErrorName.biometricDeviceUnavailable, 'Biometric Device Unavailable'],
    [SystemErrorName.dmpPanelUnavailable, 'Panel Unavailable'],
    [SystemErrorName.hmiUnavailable, 'HMI Unavailable']
]);
